import { Component, EventEmitter, Output } from '@angular/core';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';

@Component({
standalone: false,
  selector: 'app-dobry-prad-offer-info',
  styleUrls: ['./dobry-prad-offer-info.component.scss'],
  templateUrl: './dobry-prad-offer-info.component.html',
})
export class DobryPradOfferInfoComponent {
  @Output() public action: EventEmitter<void> = new EventEmitter<void>();

  // public config: SwiperConfigInterface = SwiperConfig.OFFER_MODAL_CONFIG;
  // todo
  constructor(private analyticsService: AnalyticsService) {}
  public next(): void {
    this.analyticsService.trackEvent(new AnalyticsEvent('Dobry Prad offer modal next step'));
    this.action.next();
  }
}
